var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8001 5.6H11.0001V4C11.0001 1.792 9.2081 0 7.0001 0C4.7921 0 3.0001 1.792 3.0001 4V5.6H2.2001C1.3201 5.6 0.600098 6.32 0.600098 7.2V15.2C0.600098 16.08 1.3201 16.8 2.2001 16.8H11.8001C12.6801 16.8 13.4001 16.08 13.4001 15.2V7.2C13.4001 6.32 12.6801 5.6 11.8001 5.6ZM7.0001 12.8C6.1201 12.8 5.4001 12.08 5.4001 11.2C5.4001 10.32 6.1201 9.6 7.0001 9.6C7.8801 9.6 8.6001 10.32 8.6001 11.2C8.6001 12.08 7.8801 12.8 7.0001 12.8ZM4.52009 5.59992H9.48009V3.99992C9.48009 2.63192 8.36809 1.51992 7.00009 1.51992C5.63209 1.51992 4.52009 2.63192 4.52009 3.99992V5.59992Z",
    fill: "#3F3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.84d3cef5bad628d3a30a04cdf50585c7.svg";
export { ForwardRef as ReactComponent };